var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcNavGeneral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_471_6210"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 22,
    height: 18.700000762939453,
    rx: 0
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8199999928474426
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_471_6210)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.7,21.7L4.3,21.7C2.4299999999999997,21.7,1,20.27,1,18.4L1,6.3C1,4.43,2.4299999999999997,3,4.3,3L19.7,3C21.57,3,23,4.43,23,6.3L23,18.4C23,20.27,21.57,21.7,19.7,21.7Z",
    fill: "#FFFFFF",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 5.95001220703125,
    y1: 10.25,
    x2: 8.150012254714966,
    y2: 10.25,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#333333",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "ROUND",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 11.45001220703125,
    y1: 10.25,
    x2: 18.050012588500977,
    y2: 10.25,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#DBE3E9",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "ROUND",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,1.2246468525851679e-16,-1.2246468525851679e-16,-1,36.0999755859375,26.9000244140625)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 18.04998779296875,
    y1: 12.45001220703125,
    x2: 20.249987840652466,
    y2: 12.45001220703125,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#333333",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "ROUND",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,1.2246468525851679e-16,-1.2246468525851679e-16,-1,25.0999755859375,26.9000244140625)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12.54998779296875,
    y1: 12.45001220703125,
    x2: 19.149988174438477,
    y2: 12.45001220703125,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#DBE3E9",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "ROUND",
    strokeLinejoin: "round"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNavGeneral);
export default __webpack_public_path__ + "static/media/ic_nav_general.38411ced5859fec9a1afca83df8bc2fd.svg";
export { ForwardRef as ReactComponent };